import React from 'react';

class C18ColorPicker extends React.Component {

  render() {
    return (
      <div>
        <input type="color" value={this.props.parms.color} onChange={(e)=>this.props.parms.onChange(e)} />
      </div>
    );
  }
}

export default C18ColorPicker;
